import { render, staticRenderFns } from "./SidebarNew.vue?vue&type=template&id=562ae53c&scoped=true"
import script from "./SidebarNew.vue?vue&type=script&lang=js"
export * from "./SidebarNew.vue?vue&type=script&lang=js"
import style0 from "./SidebarNew.vue?vue&type=style&index=0&id=562ae53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562ae53c",
  null
  
)

export default component.exports